// @flow

import { connect } from 'react-redux';
import { WorkInfo } from '../../components/works';

const mapState = () => ({
  className: 'possible-matches',
  backLinkTo: '/possiblematches',
  backLinkText: 'Possible Matches',
});

export default connect(
  mapState,
)(WorkInfo);
